// TODO: Refactor this to use InstantSearch

import { useEffect, useState } from 'react';
import sortBy from 'lodash.sortby';
import { getAlgoliaIndexNameEverythingSessions } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';

const useEventSessions = ({ filters = '' }) => {
    const { searchClient } = useAlgoliaClient();
    const [eventSessions, setEventSessions] = useState(null);

    useEffect(() => {
        if (!searchClient || filters.length === 0) {
            return;
        }

        (async () => {
            const { results } = await searchClient.search([
                { indexName: getAlgoliaIndexNameEverythingSessions(), params: { filters } },
            ]);

            if (results.length > 0) {
                setEventSessions(sortBy(results[0].hits, 'session_start_time'));
            }
        })();
    }, [searchClient, filters]);

    return { eventSessions };
};

export default useEventSessions;
